import {
  defaultFont,
  containerFluid,
  whiteColor,
  grayColor
} from "assets/jss/material-dashboard-react.jsx";

const footerStyle = {
  block: {},
  left: {
    float: "left!important",
    display: "block",
    fontFamily: '"Poppins", sans-serif',
    fontWeigth: "500",
    fontSize: "16px"
  },
  right: {
    margin: "0",
    fontSize: "14px",
    fontFamily: '"Poppins", sans-serif',
    fontWeigth: "500",
    float: "right!important",
    padding: "15px"
  },
  footer: {
    color: "white",
    background: "#5D6D7E",
    bottom: "0",
    borderTop: "1px solid " + grayColor[15],
    padding: "0 10px 0 10px",
    ...defaultFont,
    zIndex: 4,
    display: 'flex',
    flexDirectiion: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  container: {
    zIndex: 3,
  },
  containerFluid: {
    zIndex: 3,
    ...containerFluid,
    position: "relative"
  },
  a: {
    color: "#9B59B6",
    textDecoration: "none",
    fontWeight: "500",
    backgroundColor: "transparent"
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0",
    width: "auto"
  },
  whiteColor: {
    "&,&:hover,&:focus": {
      color: whiteColor
    }
  }
};
export default footerStyle;
